export default "__VITE_ASSET__779fcd93__"